<mat-form-field class="smp-chips no-error-placeholder full-width primary-bordered"
                [ngClass]="{'accent': accent}">
    <mat-label *ngIf="label">{{ label | translate }}</mat-label>

    <mat-chip-list #searchTermList
                   class="full-width"
                   aria-label="search"
                   [disabled]="disabled">
        <mat-chip *ngFor="let term of searchTerms; let i = index"
                  class="mat-search-chip"
                  id="{{idPrefix}}{{idSuffix}}chip_{{i}}"
                  [selectable]="true"
                  [removable]="!disabled"
                  (destroyed)="focusSearchInput()"
                  (removed)="remove(i)"
                  selected>
            <span class="bold" *ngIf="term.suggestionTransKey">{{ term.suggestionTransKey | translate }}:&nbsp;&nbsp;</span><span>{{ term.term }}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>

        <input #searchInputElement
               id="{{idPrefix}}{{idSuffix}}input_auto.new_chip"
               [(ngModel)]="searchInput"
               (keyup)="withSuggestions && onKeyup()"
               [matAutocomplete]="auto"
               [matChipInputFor]="searchTermList"
               (matChipInputTokenEnd)="add($event)">

        <mat-autocomplete #auto="matAutocomplete"
                          (optionSelected)="selected($event, searchInputElement)">
            <mat-option *ngFor="let suggestion of suggestionList?.suggestions; let y = index"
                        id="{{idPrefix}}{{idSuffix}}input_auto.suggestion_{{y}}"
                        [value]="suggestion">
                <span class="bold iq-color-2">{{ suggestion.term }}&nbsp;</span>
                <span>{{ 'search_chips.label.found_in' | translate }}&nbsp;</span>
                <span class="bold">{{ suggestion.suggestionTransKey | translate }}&nbsp;</span>
                <span>{{ 'search_chips.label.x_times' | translate : { amount: suggestion.value } }}</span>
            </mat-option>
        </mat-autocomplete>

    </mat-chip-list>

    <button mat-icon-button matSuffix
            id="{{idPrefix}}{{idSuffix}}btn.remove_all"
            *ngIf="searchTerms && searchTerms.length > 0"
            (click)="removeAll()">
        <mat-icon>clear</mat-icon>
    </button>
</mat-form-field>
